import React,{useState,useEffect,useRef} from 'react'
import PropTypes from 'prop-types'
import {useDispatch} from 'react-redux'
import {updateFinished, updatePopupNotification} from "../../../app/action"
import ACCOUNT_API from "../../../utilities/api/account"
import {withRouter} from "react-router-dom"
import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse
} from "../../../utilities/function/apiResponse";
import globalCookies from "../../../utilities/function/cookies";
import Loading from "../../shared/loading";

let Paypal = (props) =>{
  const [requestInvoice,setRequestInvoice] = useState({})
  const dispatch = useDispatch()
  const {history} = props
  const initFlag = useRef(false)
  useEffect(()=>{
    if(!initFlag.current) {
      const access_token = globalCookies.get('access_token')



      if (access_token && localStorage.getItem('paypalOrder') && JSON.parse(localStorage.getItem('paypalOrder'))) {
        const paypalOrder = JSON.parse(localStorage.getItem('paypalOrder'))
        if (paypalOrder && paypalOrder.invoice_id && paypalOrder.order_id && requestInvoice.status === undefined) {
          const {invoice_id, order_id} = paypalOrder
          setRequestInvoice({
            ...requestInvoice,
            status: 'loading'
          })
          ACCOUNT_API.setAccessToken(access_token)
          ACCOUNT_API.getInvoice(paypalOrder.invoice_id).then(successresponse => {
            const data = getDataFromSuccessResponse(successresponse)
            setRequestInvoice({
              ...requestInvoice,
              status: 'success',
              data
            })
            if (data && data.attributes) {
              const {status} = data.attributes
              if (status === "Paid") {
                window.setTimeout(() => {
                  updateFinished(dispatch, paypalOrder)
                  history.push(`${history.location.pathname}?a=checkout&step=finished`)
                }, 300)
              } else {
                history.push(`${history.location.pathname}?a=checkout&step=payinvoice&invoice=${invoice_id}&order=${order_id}`)
              }
            } else {
              history.push(`${history.location.pathname}?a=checkout&step=payinvoice&invoice=${invoice_id}&order=${order_id}`)
            }
          }, errorresponse => {
            const error = getErrorFromFailResponse(errorresponse)
            updatePopupNotification(dispatch, {
              status: 'error',
              error
            })
            history.push(history.location.pathname)
          })
        }

      } else {
        history.push(history.location.pathname)
      }
      localStorage.removeItem('paypalOrder')
      initFlag.current = true
    }
  },[requestInvoice,dispatch,history])
  return (<Loading wrapper={true}/>)
}

Paypal = withRouter(Paypal)

Paypal.propTypes={
  history: PropTypes.any
}

export default Paypal